export default __webpack_public_path__ + "static/media/right-arrow.060e283a.svg";